import {
  GET_CHAUFFEURS,
  API_RESPONSE_SUCCESS,
  API_RESPONSE_ERROR,

  ADD_CHAUFFEUR_SUCCESS,
  ADD_CHAUFFEUR_FAIL,
  
  UPDATE_CHAUFFEUR_SUCCESS,
  UPDATE_CHAUFFEUR_FAIL,
} from "./actionType";

const INIT_STATE = {
  chauffeurs: [],
  error: {},
};

const Chauffeur = (state = INIT_STATE, action) => {
  switch (action.type) {
    case API_RESPONSE_SUCCESS:
      switch (action.payload.actionType) {
        case GET_CHAUFFEURS:
          return {
            ...state,
            chauffeurs: action.payload.data,
            isChauffeurCreated: false,
            isChauffeurSuccess: true
          };
        
        default:
          return { ...state };
      }
    case API_RESPONSE_ERROR:
      switch (action.payload.actionType) {
        case GET_CHAUFFEURS:
          return {
            ...state,
            error: action.payload.error,
            isChauffeurCreated: false,
            isChauffeurSuccess: false
          };
        
        default:
          return { ...state };
      }

    case ADD_CHAUFFEUR_SUCCESS:
      return {
        ...state,
        isChauffeurCreated: true,
        chauffeurs: [...state.chauffeurs, action.payload.data],
        isChauffeurAdd: true,
        isChauffeurAddFail: false
      };

    case ADD_CHAUFFEUR_FAIL:
      return {
        ...state,
        error: action.payload,
        isChauffeurAdd: false,
        isChauffeurAddFail: true
      };

    case UPDATE_CHAUFFEUR_SUCCESS:
      return {
        ...state,
        chauffeurs: state.chauffeurs.map(chauffeur =>
          chauffeur.id === action.payload.id
            ? { ...chauffeur, ...action.payload }
            : chauffeur
        ),
        isChauffeurUpdate: true,
        isChauffeurUpdateFail: false
      };

    case UPDATE_CHAUFFEUR_FAIL:
      return {
        ...state,
        error: action.payload,
        isChauffeurUpdate: false,
        isChauffeurUpdateFail: true
      };

    default:
      return { ...state };
  }
};

export default Chauffeur;
